/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Responses_StoreInventoryDetail = {
  id?: number;
  name?: string;
  searchItemType?: Luci_Shopping_Api_Responses_StoreInventoryDetail.searchItemType;
  thumbnailImageUrl?: string;
  priceLow?: number;
  priceHigh?: number;
  itemsCount?: number;
};
export namespace Luci_Shopping_Api_Responses_StoreInventoryDetail {
  export enum searchItemType {
    PRODUCT_GROUP = 'ProductGroup',
    PRODUCT_BUNDLE = 'ProductBundle',
  }
}

